<script setup lang="ts">
import { computed } from 'vue';
import useDomain from '@/composables/domainDependable';
import StfFooter from '@/components/StfFooter.vue';
import ApplicationBanner from '@/components/ApplicationBanner.vue';
import StickyBannersWrapper from '@/components/StickyBannersWrapper.vue';

const domain = useDomain();

const menu = ['Home', 'Pricing', 'FAQ', 'About'];

const navItems = computed(() => {
    const baseUrl = domain.website;
    
    return menu.map(itemName => {
        const menuItem = domain.menuItems.find(item => item.label === itemName);

        const href = menuItem ? `${baseUrl}${menuItem.url}` : baseUrl;

        return { text: itemName, href: href };
    });
});
</script>

<template>
    <stf-nav-bar :nav-items="navItems"/>
    <StickyBannersWrapper />
    <ApplicationBanner />
    <stf-container>
        <slot></slot>
    </stf-container>
    <stf-footer></stf-footer>
</template>

